import {Collapse, FormControl, FormControlLabel, Grow, SelectChangeEvent} from "@mui/material";
import StyledDropdown from "../../CommonComponents/StyledDropdown/StyledDropdown";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import React, {useEffect, useState} from "react";
import StyledTextarea from "../../CommonComponents/StyledTextarea/StyledTextarea";
import Box from "@mui/material/Box";
import {useTheme} from "../../../contexts/theme";
import {Stream, Track} from "../../../types/dataSourceTypes";
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import {Dayjs} from "dayjs";
import Grid from "@mui/material/Grid";
import StyledSwitch from "../../CommonComponents/StyledSwitch/StyledSwitch";
import StyledIconButton from "../../CommonComponents/StyledIconButton/StyledIconButton";
import DeleteIcon from '@mui/icons-material/Delete';

interface  TracksformProps {
    tracks: Track;
    index: number;
    handleChangeTrack: (nameDS:  keyof Track,  value: string | null, indexTrack: number) => void;
    typeMediaTrack?: string[];
    onRemoveTrack?: (trackIndex: number) => void;
}


export default function Tracksform(
    {tracks, handleChangeTrack, typeMediaTrack, index, onRemoveTrack}: TracksformProps
){

    const theme = useTheme();
    const [advancedOptions, setAdvancedOptions] = useState<boolean>(false);



    const handleStreamChange = (name: keyof Track, event: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>) => {

        handleChangeTrack(name, event.target.value, index);

    }



    return (
        <Box sx={{
            border: `1px solid ${theme.palette.lightGrey}`,
            borderRadius: theme.spacing.xs,
            padding: theme.spacing.md,
        }}>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={5.5} xl={5.5}>
                    <FormControl fullWidth={true}>
                        {typeMediaTrack &&  <StyledDropdown
                            paddingBottom={theme.spacing.md}
                            options={typeMediaTrack}
                            label="Select the type of track"
                            id='outlined' value={tracks.typeTrack}
                            onChange={(event: SelectChangeEvent<string>) => {handleStreamChange('typeTrack', event)}}
                        />
                        }


                            <StyledSwitch checked={advancedOptions} onChange={()=>{setAdvancedOptions((prev) => !prev)}} label={"Show advanced options"} />


                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={5.5} xl={5.5}>
                    <FormControl fullWidth={true}>
                        <TextinputField placeholder='Index' label={'Index'} type='number' variant={'outlined'}
                                        value={tracks.info.index}
                                        size={'medium'}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleStreamChange('info',event)}}
                                        name={'index'}
                                        id={"outlined-basic"}
                                        borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                        backgroundColor={'none'}
                                        color={theme.palette.white}
                                        borderColor={theme.palette.white}
                                        borderRadius={theme.border.width.hard}

                        ></TextinputField>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
                    {onRemoveTrack && <Box width={'100%'} display={'flex'} justifyContent={'flex-end'} sx={{marginBottom: theme.spacing.md}}>
                        <StyledIconButton  width={'55px'} height={'57px'} onClick={() => onRemoveTrack(index)}>
                            <DeleteIcon fontSize={'medium'}></DeleteIcon>
                        </StyledIconButton>
                    </Box>
                    }
                </Grid>

            </Grid>

            <Collapse in={advancedOptions}>
                <Grid container spacing={2} direction={"row"} paddingTop={theme.spacing.md}>
                    <Grow in={advancedOptions}>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <FormControl fullWidth={true}>
                                <TextinputField placeholder='Codec' label={'Codec'} type='text' variant={'outlined'}
                                                value={tracks.codec}
                                                size={'medium'}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleStreamChange('codec',event)}}
                                                name={'name'}
                                                id={"outlined-basic"}
                                                borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                                backgroundColor={'none'}
                                                color={theme.palette.white}
                                                borderColor={theme.palette.white}
                                                borderRadius={theme.border.width.hard}

                                ></TextinputField>


                            </FormControl>

                        </Grid>



                    </Grow>
                    <Grow in={advancedOptions}  style={{ transformOrigin: '0 0 0' }}
                          {...(advancedOptions? { timeout: 1000 } : {})}
                    >
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <FormControl fullWidth={true}>


                                <TextinputField placeholder='Codec_Version' label={'Codec_Version'} type='text' variant={'outlined'}
                                                value={tracks.codec_version}
                                                size={'medium'}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleStreamChange('codec_version',event)}}
                                                name={'name'}
                                                id={"outlined-basic"}
                                                borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                                backgroundColor={'none'}
                                                color={theme.palette.white}
                                                borderColor={theme.palette.white}
                                                borderRadius={theme.border.width.hard}

                                ></TextinputField>

                            </FormControl>
                        </Grid>

                    </Grow>
                </Grid>
            </Collapse>












        </Box>


    )

}